module.exports = __webpack_public_path__ + "static/img/role-en.9a65983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/role-en.png
// module id = /tNA
// module chunks = 1